import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { CurrencyFormatOptions } from '@interfaces/currency-format-options';

interface CurrencyServiceData {
    options: CurrencyFormatOptions;
}

@Injectable({
    providedIn: 'root'
})
export class CurrencyService {
    private data: CurrencyServiceData = {
        options: {}
    };

    private changesSubject$: BehaviorSubject<CurrencyFormatOptions> = new BehaviorSubject({});

    changes$: Observable<CurrencyFormatOptions> = this.changesSubject$.asObservable();

    public currenciesSubject$: BehaviorSubject<any> = new BehaviorSubject({});

    currencies$: Observable<any> = this.currenciesSubject$.asObservable();

    // Track if currency is ready to be displayed (rates loaded)
    private isReadySubject$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public isReady$: Observable<boolean> = this.isReadySubject$.asObservable();

    get options(): CurrencyFormatOptions {
        return this.data?.options;
    }
    set options(value: CurrencyFormatOptions) {
        this.data.options = value;
        this.changesSubject$.next(value);
    }

    get isReady(): boolean {
        return this.isReadySubject$.value;
    }
    
    set isReady(value: boolean) {
        this.isReadySubject$.next(value);
    }

    constructor() { }
}
